module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (!_vm.isLoading) ? _c('userTypeSelection-form', {
    ref: "basicFinancialInformation",
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.userCommentCategories,
      "showToggleAll": false,
      "placeholder": "Select relevant categories",
      "optionLabel": "name"
    },
    model: {
      value: (_vm.userCommentCategory),
      callback: function($$v) {
        _vm.userCommentCategory = $$v
      },
      expression: "userCommentCategory"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below")]), _vm._v(" "), (_vm.savingComment) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saving-color"
  }, [_vm._v("[ Saving... ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaved) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saved-color"
  }, [_vm._v("[ Saved ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaveError) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-error-color"
  }, [_vm._v("[ Not Saved ]")]) : _vm._e(), _vm._v(" "), _c('restricted-textarea', {
    staticClass: "restricted-textarea",
    attrs: {
      "limit": 255,
      "input": _vm.userCommentInput,
      "id": "comment",
      "required": false,
      "showNotice": false,
      "showLimit": true,
      "textColorClass": 'vinous-text',
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), (!_vm.isLoading) ? _c('basicFinancial-information', {
    ref: "basicFinancialInformation",
    attrs: {
      "basicFinancialInformation": _vm.user
    },
    on: {
      "validated": _vm.basicInformationValidated,
      "emailUpdated": _vm.handleEmailChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": !_vm.emailIsValid
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Provide investor log in\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Enable MFA\n          ")])]), _vm._v(" "), (_vm.user.residentialAddress && _vm.user.mailingAddress) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Business address',
      "residentialAddress": _vm.user.residentialAddress,
      "secondTitle": 'Mailing address',
      "mailingAddress": _vm.user.mailingAddress,
      "is-admin": true
    },
    on: {
      "validated": _vm.addressesValidated
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've changed the default account",
      "subtitle": "",
      "closeAction": _vm.hideDefaultAccountAlert,
      "isShowing": _vm.showDefaultAccountChanged
    }
  }), _vm._v(" "), (_vm.user !== undefined) ? _c('AccountsList', {
    attrs: {
      "userType": _vm.user.userType,
      "defaultAccountId": _vm.user.defaultAccountId,
      "accounts": _vm.user.accounts
    },
    on: {
      "confirmedChangeDefaultAccount": _vm.changedDefaultAccountId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Comment Category")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f439cefa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditFinancialAdvisor.vue
// module id = 2210
// module chunks = 1